<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}" style='background-color: #000000;'>
    <div #header1 class="container green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="https://www.galatrails.com/wp-content/uploads/2024/06/logo-galatrails-version-blanco.webp"
                height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://www.galatrails.com/" class="navbar-brand"
            target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <span class="custom-logo" width="180" height="50"></span>
        </a>
        <div class="containerMenu navbar-collapse collapse" style="justify-content: center;">
            <ul class="navbar-nav menuContainer"
                style="width: inherit; border: 1px solid #f6f6f6; border-radius: 50px; padding: 12px 30px;">
                <li class="nav-item menuItem"><a href="https://www.galatrails.com/" target="_blank">HOME</a></li>
                <li class="nav-item menuItem"><a href="https://www.galatrails.com/about-us/" target="_blank">ABOUT
                        US</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galatrails.com/tours/" target="_blank">TOURS</a></li>
                <li class="nav-item menuItem"><a href="https://agencies.galavail.com/galatrails/search/"
                        target="_blank">CRUISES</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galatrails.com/extension/"
                        target="_blank">EXTENSION</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galatrails.com/before-you-go/" target="_blank">Q
                        &amp; A</a></li>
            </ul>

        </div>
        <div class="button-container">
            <div>
                <a class="lets-talk-button" href="https://www.galatrails.com/customize-tour/" style="color: #000000;">
                    LET´S TALK
                </a>
            </div>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <a class="wish" (click)="goFavorites()" [ngStyle]="{'color':'#'+companyParamsService.getMainColor()}"
                    target="_blank">
                    <i class="fa fa-heart-o"></i>
                </a>
                <span class="tooltip-text">wishlist</span>
            </div>
        </div>


    </div>
    <div class="responsiveHeader">
        <div class="container green containerHeader"
            style="display:flex;justify-content:  space-between; flex-direction: row!important;">
            <img src="https://www.galatrails.com/wp-content/uploads/2024/06/logo-galatrails-version-blanco.webp"
                width="150" />
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 1em;">
                <i class="fa fa-bars fa-2x" style="padding-left: 20px;"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://www.galatrails.com/" target="_blank">HOME</a></li>
        <li class="nav-item menuItem"><a href="https://www.galatrails.com/about-us/" target="_blank">ABOUT US</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galatrails.com/tours/" target="_blank">TOURS</a></li>
        <li class="nav-item menuItem"><a href="https://agencies.galavail.com/galatrails/search/"
                target="_blank">CRUISES</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galatrails.com/extension/" target="_blank">EXTENSION</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galatrails.com/before-you-go/" target="_blank">Q &amp; A</a>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <a class="wish" (click)="goFavorites()" [ngStyle]="{'color':'#'+companyParamsService.getMainColor()}">
            <i class="fa fa-heart-o"></i>
        </a>
        <span class="tooltip-text">wishlist</span>
    </div>

</nav>